import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getTempLinkMeta, validateTempLink } from "../api/templinkAPI";
import styled from "styled-components";
import { Button, Input } from "antd";
import InvalidLinkScreen from "../component/common/InvalidLinkScreen";

const TempLinkEntry = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [hasPassword, setHasPassword] = useState<boolean>(false);
  const [password, setPassword] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    if (!uuid) return;
    getTempLinkMeta(uuid).then((meta) => {
      if (!meta) {
        setIsError(true);
      } else {
        setHasPassword(meta.hasPassword);
        if (!meta.hasPassword) {
          handleValidate(uuid);
        } else {
          setIsLoading(false);
        }
      }
    });
  }, [uuid]);

  const handleValidateError = (e: unknown) => {
    const msg = e instanceof Error ? e.message : "알 수 없는 오류가 발생했습니다.";
    if (msg.includes("만료")) {
      setIsError(true);
    } else {
      setErrorMsg(msg);
    }
    setIsLoading(false);
  };

  const handleValidate = async (targetUuid: string, pw?: string) => {
    setIsLoading(true);
    setErrorMsg("");
    try {
      const result = await validateTempLink({ uuid: targetUuid, ...(pw !== undefined ? { password: pw } : {}) });
      const target = searchParams.get("target");
      const nextPath = (target === "consultation" || target === "viewer")
        ? `/demo/viewer/${result!.postId}?mode=${target}`
        : `/demo/viewer/${result!.postId}`;
      navigate(nextPath, { replace: true });
    } catch (e) {
      handleValidateError(e);
    }
  };

  const handleSubmit = () => {
    if (!uuid) return;
    handleValidate(uuid, password);
  };

  if (isError) {
    return <InvalidLinkScreen />;
  }

  if (isLoading) {
    return (
      <Container>
        <Box>
          <Desc>링크를 확인하는 중...</Desc>
        </Box>
      </Container>
    );
  }

  return (
    <Container>
      <Box>
        <Title>비밀번호를 입력하세요</Title>
        <Input.Password
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onPressEnter={handleSubmit}
          placeholder="비밀번호"
          style={{ marginBottom: "12px" }}
        />
        {errorMsg && <ErrorMsg>{errorMsg}</ErrorMsg>}
        <Button type="primary" block onClick={handleSubmit}>
          확인
        </Button>
      </Box>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #0a1929;
`;

const Box = styled.div`
  text-align: center;
  padding: 48px 64px;
  background-color: #051e34;
  border: 1px solid #1e3a52;
  border-radius: 12px;
  min-width: 320px;
`;

const Title = styled.h2`
  color: #fff;
  font-size: 1.3rem;
  margin: 0 0 20px;
`;

const Desc = styled.p`
  color: #8899aa;
  font-size: 0.95rem;
  margin: 0;
`;

const ErrorMsg = styled.p`
  color: #ff4d4f;
  font-size: 0.85rem;
  margin: 0 0 8px;
`;

export default TempLinkEntry;
